import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Path from '../../../../route/Path';
import DefaultLayout from '../../../../layouts/DefaultLayout';
import MainContentLayout from '../../../../layouts/MainContentLayout';
import LoadingProgress from '../../../../components/commonUI/LoadingProgress';
import LoadInitError from '../../../../components/commonUI/LoadInitError';
import { getScalpDataByBatchingGroup, batchDeliverToLab, deleteScalpDataGroup, individualDeliverToLab, deleteScalpData } from '../../../../services/api/1C';
import moment from 'moment';
import NoData from '../../../../components/commonUI/NoData';
import BatchDeliverModal from './BatchDeliverModal';
import IndividualDeliverModal from './IndividualDeliverModal';
import NavigationBackBtn from '../../../../components/common/NavigationBackButton';
import { DELIVERY_STATUS_LABELS } from '../../../../constants';
import BatchDeliveryDetailItem from '../../../../components/ScalpDelivery/BatchDeliveryDetailItem';
import { toast } from 'react-toastify';
import ConfirmDeleteDialog from '../../../../components/CommonDialog/ConfirmDeleteDialog';

function BatchDeliverScalpLabDetailPage() {
  const navigate = useNavigate();
  const customerNo = useParams();

  const [openModal, setOpenModal] = useState(false);
  const [openIndividualModal, setOpenIndividualModal] = useState(false);
  const [isIndividualMode, setIsIndividualMode] = useState(false);
  const [selectedKitIds, setSelectedKitIds] = useState([]);
  const [fetchHistoryOrderDetail, setFetchHistoryOrderDetail] = useState({
    isLoading: false,
    data: null,
    error: null,
  });
  const [isOpenDialog, setIsOpenDialog] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const loadHistoryOrderDetail = () => {
    setFetchHistoryOrderDetail({
      isLoading: true,
      data: null,
      error: null,
    });
    getScalpDataByBatchingGroup(customerNo.group_id)
      .then((res) => {
        setFetchHistoryOrderDetail({
          isLoading: false,
          data: res.data,
          error: null,
        });
      })
      .catch((error) => {
        setFetchHistoryOrderDetail({
          isLoading: false,
          data: null,
          error: error,
        });
      });
  };

  useEffect(() => {
    loadHistoryOrderDetail();
  }, []);

  const handleOnCloseClicked = () => {
    setOpenModal(false);
  };

  const handleOnSendClicked = () => {
    batchDeliverToLab(customerNo.group_id)
      .then((res) => {
        setOpenModal(false);
        alert('一括発送しました');
        navigate(Path.batchDeliverScalpLab);
      })
      .catch((e) => {
        const errorMessage = e.response?.data?.message;
        if (errorMessage === 'error.E400') {
          toast.error(`グループ「'${fetchHistoryOrderDetail.data?.manageCode}」はすでに発送済みです。`);
        } else {
          toast.error('発送処理に失敗しました');
        }
      });
  };

  // --- 個別発送 handlers ---
  const handleToggleIndividualMode = () => {
    if (isIndividualMode) {
      setIsIndividualMode(false);
      setSelectedKitIds([]);
    } else {
      setIsIndividualMode(true);
      setSelectedKitIds([]);
    }
  };

  const handleCheckChanged = (kitId, checked) => {
    if (checked) {
      setSelectedKitIds((prev) => [...prev, kitId]);
    } else {
      setSelectedKitIds((prev) => prev.filter((id) => id !== kitId));
    }
  };

  const handleIndividualSend = () => {
    individualDeliverToLab(customerNo.group_id, selectedKitIds)
      .then((res) => {
        setOpenIndividualModal(false);
        setIsIndividualMode(false);
        setSelectedKitIds([]);
        alert('選択した検体を発送しました');
        navigate(Path.batchDeliverScalpLab);
      })
      .catch((e) => {
        console.log(e);
        const errorMessage = e.response?.data?.message;
        if (errorMessage === 'error.E400') {
          toast.error('この検体はすでに発送済みです。');
        } else {
          toast.error('発送処理に失敗しました');
        }
      });
  };

  const handleDelete = (item) => {
    setIsOpenDialog(true);
    setSelectedItem(item);
  };

  const handleDeleteConfirm = async () => {
    try {
      await deleteScalpData(selectedItem._id);
      toast.success('削除成功');
      setFetchHistoryOrderDetail((prev) => ({
        ...prev,
        data: {
          ...prev.data,
          inspectionKitIds:
            prev.data?.inspectionKitIds?.filter((kit) => kit._id !== selectedItem._id) || [],
        },
      }));

      if (fetchHistoryOrderDetail.data?.inspectionKitIds.length === 1) {
        try {
          await deleteScalpDataGroup(fetchHistoryOrderDetail.data._id);
          navigate(-1);
        } catch (error) {
          console.log('error', error);
        }
      }
    } catch (error) {
      console.error(error);
    }
  }

  const isDeliveryDisabled = fetchHistoryOrderDetail.data?.salonDeliverStatus === 'pending' ? false : true;

  const RenderStatus = () => {
    const text = DELIVERY_STATUS_LABELS[fetchHistoryOrderDetail.data?.salonDeliverStatus || 'pending'];
    if (fetchHistoryOrderDetail.data?.salonDeliverStatus === 'pending') {
      return <p className="text-subtitle bg-gray-base w-fit px-3 py-1 rounded-full">{text}</p>;
    }
    return <p className="text-blue-btn-primary bg-[#DEF4FF] w-fit px-3 py-1 rounded-full">{text}</p>;
  };

  return (
    <DefaultLayout>
      <MainContentLayout
        pageTitle={
          <>
            <p>ラボ</p>
          </>
        }
      >
        <div className="w-full h-full">
          <NavigationBackBtn
            text={`管理番号：${fetchHistoryOrderDetail.data?.manageCode || ''}`}
            actionButton={<RenderStatus />}
          />
          <div className="px-4 md:px-0">
            <div className="flex justify-between items-center my-4">
              <div className="flex items-center gap-4 text-sm">
                <div>検体数： {fetchHistoryOrderDetail.data?.inspectionKitIds?.length || '0'}</div>
                <div>
                  発送日時：
                  {fetchHistoryOrderDetail.data?.salonDeliverStatus == 'pending'
                    ? '未発送'
                    : fetchHistoryOrderDetail.data?.salonDeliverDate
                      ? moment(fetchHistoryOrderDetail.data.salonDeliverDate).format('YYYY-MM-DD HH:mm')
                      : '-'}
                </div>
              </div>
              <div className="flex items-center gap-2">
                {!isDeliveryDisabled && (
                  <button
                    onClick={handleToggleIndividualMode}
                    type="button"
                    className={`h-9 px-4 text-sm button-size ${
                      isIndividualMode
                        ? 'bg-gray-400 text-white'
                        : 'bg-blue-btn-primary'
                    }`}
                  >
                    {isIndividualMode ? 'キャンセル' : '個別発送'}
                  </button>
                )}

                {!isIndividualMode && (
                  <button
                    onClick={() => {
                      setOpenModal(true);
                    }}
                    type="button"
                    className={`button-size ${isDeliveryDisabled ? 'hidden' : 'bg-blue-btn-primary'} h-9 w-20 text-sm`}
                    disabled={isDeliveryDisabled}
                  >
                    一括発送
                  </button>
                )}
              </div>
            </div>
            <div className="w-full h-full">
              <div className="w-full h-full">
                {fetchHistoryOrderDetail.isLoading ? <LoadingProgress /> : null}

                {!fetchHistoryOrderDetail.isLoading &&
                fetchHistoryOrderDetail.error &&
                fetchHistoryOrderDetail.data?.inspectionKitId ? (
                  <LoadInitError error={fetchHistoryOrderDetail.error} />
                ) : null}
                {!fetchHistoryOrderDetail.isLoading && !fetchHistoryOrderDetail.error ? (
                  Array.isArray(fetchHistoryOrderDetail.data?.inspectionKitIds) &&
                  fetchHistoryOrderDetail.data?.inspectionKitIds.length > 0 ? (
                    <div>
                      {fetchHistoryOrderDetail.data?.inspectionKitIds.map((item, index) => (
                        <BatchDeliveryDetailItem
                          key={index}
                          data={item}
                          isIndividualMode={isIndividualMode}
                          isChecked={selectedKitIds.includes(item._id)}
                          onCheckChanged={handleCheckChanged}
                          onDelete={() => handleDelete(item)}
                        />
                      ))}
                    </div>
                  ) : (
                    <NoData />
                  )
                ) : (
                  <NoData />
                )}
              </div>
            </div>
          </div>
          {isIndividualMode && selectedKitIds.length > 0 && (
            <div className="fixed bottom-0 md:max-w-5xl left-1/2 -translate-x-1/2 w-full max-w-md p-4 bg-transparent">
              <button
                onClick={() => setOpenIndividualModal(true)}
                type="button"
                className="w-full h-12 bg-blue-btn-primary text-white text-base font-medium rounded-lg"
              >
                発送する
              </button>
            </div>
          )}
          {/* Modal 一括発送 */}
          <BatchDeliverModal
            openDialog={openModal}
            handleOnCloseClicked={handleOnCloseClicked}
            content={'検体  ' + fetchHistoryOrderDetail.data?.inspectionKitIds.length + '  個'}
            handleOnSendClicked={handleOnSendClicked}
          ></BatchDeliverModal>

          {/* Modal 個別発送確認 */}
          <IndividualDeliverModal
            openDialog={openIndividualModal}
            handleOnCloseClicked={() => setOpenIndividualModal(false)}
            selectedCount={selectedKitIds.length}
            handleOnSendClicked={handleIndividualSend}
          />

          <ConfirmDeleteDialog
            open={isOpenDialog}
            handleClose={() => setIsOpenDialog(false)}
            confirmTitle={`検体 ${selectedItem?.inspectionKitId} を削除しますか？`}
            confirmTitleAgain="本当に以下の検体を削除しますか？"
            confirmMessageAgain={selectedItem?.inspectionKitId}
            deleteCompleteTitle={`検体 ${selectedItem?.inspectionKitId} を削除しました。`}
            deleteCompleteBtnLabel="終了"
            deleteCompleteAction={() => {
              setIsOpenDialog(false);
            }}
            deleteAction={handleDeleteConfirm}
            handleDeleteError={() => {
              setIsOpenDialog(false);
            }}
          />
        </div>
      </MainContentLayout>
    </DefaultLayout>
  );
}

export default BatchDeliverScalpLabDetailPage;
